// Enums
import { PostMessageOutgoingAction } from '@/enums/PostMessageAction';

// Libraries
import { Dispatch } from 'redux';
import { History } from 'history';

// Redux
import store from '@/redux/store';
import { resetPostMessageRetry } from '@/redux/modules/post-message';

// Types
import { PostMessageRetry } from '@/redux/modules/types/post-message';

export abstract class AbstractStrategy {
  execute(dispatch: Dispatch, context?: object, history?: History<unknown>) {
    throw new Error('AbstractStrategy execute function needs to be implemented');
  }

  evaluateRetry(action: PostMessageOutgoingAction, retryStatus: PostMessageRetry): boolean {
    const shouldRetry: boolean = retryStatus.executionCount !== retryStatus.executionLimit;

    if (!shouldRetry) {
      resetPostMessageRetry(action)(store.dispatch, store.getState, null);
    }

    return shouldRetry;
  }
}
